import React, { useState } from "react";
import "./Visa.css";
import { Col, Container, Row, Form } from "react-bootstrap";
import { MdEmail } from "react-icons/md";
import { FaPhoneAlt } from "react-icons/fa";
import { FaLocationDot } from "react-icons/fa6";

function Visa() {
  const [formData, setFormData] = useState({
    name: "",
    email: "",
    phone: "",
    subject: "",
    message: "",
  });

  const handleChange = (e) => {
    setFormData({ ...formData, [e.target.name]: e.target.value });
  };

  const handleSubmit = (e) => {
    e.preventDefault();
    alert("Your enquiry has been submitted!");
    setFormData({ name: "", email: "", phone: "", subject: "", message: "" });
  };

  return (
    <div className="visa-page">
      <Container>
        <Row className="visa-row">
          {/* Left Info Panel */}
          <Col md={6} className="visa-info">
            <h2>Get in Touch</h2>
            <p>We’re here to help you with your visa queries. Reach out anytime!</p>

            <div className="info-card">
              <FaPhoneAlt className="icon" />
              <div>
                <h5>Call Us 24/7</h5>
                <p>+966 58 085 8030</p>
              </div>
            </div>

            <div className="info-card">
              <MdEmail className="icon" />
              <div>
                <h5>Email Us</h5>
                <p>support@volarpro.com</p>
              </div>
            </div>

            <div className="info-card">
              <FaLocationDot className="icon" />
              <div>
                <h5>Our Office</h5>
                <p>30 N Gould St Ste R, Sheridan, WY 82801</p>
              </div>
            </div>
          </Col>

          {/* Right Form Panel */}
          <Col md={6} className="visa-form">
            <div className="form-card">
              <h2>Send an Enquiry</h2>
              <Form onSubmit={handleSubmit}>
                <Form.Group className="mb-3">
                  <Form.Control
                    type="text"
                    name="name"
                    placeholder="Your Name"
                    value={formData.name}
                    onChange={handleChange}
                    required
                  />
                </Form.Group>
                <Form.Group className="mb-3">
                  <Form.Control
                    type="email"
                    name="email"
                    placeholder="Your Email"
                    value={formData.email}
                    onChange={handleChange}
                    required
                  />
                </Form.Group>
                <Form.Group className="mb-3">
                  <Form.Control
                    type="tel"
                    name="phone"
                    placeholder="Your Phone Number"
                    value={formData.phone}
                    onChange={handleChange}
                    required
                  />
                </Form.Group>
                <Form.Group className="mb-3">
                  <Form.Control
                    type="text"
                    name="subject"
                    placeholder="Subject"
                    value={formData.subject}
                    onChange={handleChange}
                  />
                </Form.Group>
                <Form.Group className="mb-3">
                  <Form.Control
                    as="textarea"
                    rows={5}
                    name="message"
                    placeholder="Your Message"
                    value={formData.message}
                    onChange={handleChange}
                    required
                  />
                </Form.Group>
                <button type="submit" className="submit-btn">
                  Submit
                </button>
              </Form>
            </div>
          </Col>
        </Row>
      </Container>
    </div>
  );
}

export default Visa;
